// extracted by mini-css-extract-plugin
export default {"list":"MenuDocuments_list__7hFA2","link":"MenuDocuments_link__QazW6","linkName":"MenuDocuments_linkName__JAiZy"};